import Typography from "@mui/material/Typography";
import BasicTabs from "../../components/CustomTabPanel";
import {
    Autocomplete,
    Box,
    Button, Checkbox,
    FormControl, FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
    useTheme
} from "@mui/material";
import ErrorHandlingTextField, {validateNumber, validateRequired} from "../../components/ErrorHandlingTextField";
import {useContext} from "react";
import ReservationContext from "../../context/ReservationContext";
import countries from "../../utils/countries";
import HouseRoundedIcon from '@mui/icons-material/HouseRounded';
import ConfigContext from "../../context/ConfigContext";

const SelectPaymentData = () => {
    const {
        billingData,
        setBillingData,
        error,
        setError,
        paymentTypeMap,
        isBillingFilled,
        isError,
        reserve
    } = useContext(ReservationContext)
    const theme = useTheme()
    const style = {color: theme.palette.primary[600]}
    const {baseUrl} = useContext(ConfigContext)

    const aszfUrl = `${baseUrl}/media/aszf.pdf`
    const adatUrl = `${baseUrl}/media/adat.pdf`

    const checkError = (v, name) => {
        setError({...error, [name]: v});
    }

    const tabs = [{
        name: 'Magánszemély', content: <Stack spacing={1}>
            <Typography variant='caption' sx={{color: theme.palette.primary[500]}}>Számlázási név*</Typography>
            <ErrorHandlingTextField check={v => checkError(v, 'billing_name')} validators={[validateRequired]}
                                    value={billingData?.billing_name || ''} variant='standard' name="billing_name"
                                    onValChange={e => setBillingData({...billingData, billing_name: e.target.value})}/>

            <Typography variant='caption' sx={{color: theme.palette.primary[500]}}>Ország*</Typography>
            <Autocomplete
                id="country-select-person"
                sx={{width: '100%'}}
                options={countries}
                autoHighlight
                value={billingData?.country || null}
                onChange={(event, newValue) => {
                    setBillingData({...billingData, country: newValue});
                }}
                isOptionEqualToValue={(option, value) => option.code === value.code}
                getOptionLabel={(option) => option.label}
                renderOption={(props, option) => (
                    <Box component="li" sx={{'& > img': {mr: 2, flexShrink: 0}}} {...props}>
                        <img
                            loading="lazy"
                            width="20"
                            src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                            srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                            alt=""
                        />
                        {option.label} ({option.code})
                    </Box>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant='standard'
                        fullWidth
                        inputProps={{
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                        }}
                    />
                )}
            />

            <Stack spacing={1} direction='row' sx={{width: '100%'}}>
                <Stack spacing={1} sx={{width: '100%'}}>

                    <Typography variant='caption' sx={{color: theme.palette.primary[500]}}>Irányítószám*</Typography>
                    <ErrorHandlingTextField check={v => checkError(v, 'postal_code')}
                                            validators={[validateRequired, validateNumber]}
                                            value={billingData?.postal_code || ''} variant='standard'
                                            name="postal_code"
                                            onValChange={e => setBillingData({
                                                ...billingData,
                                                postal_code: e.target.value
                                            })}/>
                </Stack>


                <Stack spacing={1} sx={{width: '100%'}}>
                    <Typography variant='caption' sx={{color: theme.palette.primary[500]}}>Város*</Typography>
                    <ErrorHandlingTextField check={v => checkError(v, 'city')}
                                            validators={[validateRequired]}
                                            value={billingData?.city || ''} variant='standard' name="city"
                                            onValChange={e => setBillingData({...billingData, city: e.target.value})}/>
                </Stack>
            </Stack>

            <Typography variant='caption' sx={{color: theme.palette.primary[500]}}>Megye*</Typography>
            <ErrorHandlingTextField check={v => checkError(v, 'state')}
                                    validators={[validateRequired]}
                                    value={billingData?.state || ''} variant='standard' name="address"
                                    onValChange={e => setBillingData({...billingData, state: e.target.value})}/>

            <Typography variant='caption' sx={{color: theme.palette.primary[500]}}>Cím*</Typography>
            <ErrorHandlingTextField check={v => checkError(v, 'address')}
                                    validators={[validateRequired]}
                                    value={billingData?.address || ''} variant='standard' name="address"
                                    onValChange={e => setBillingData({...billingData, address: e.target.value})}/>

            <Typography variant='caption' sx={{color: theme.palette.primary[500]}}>Cím második sora</Typography>
            <ErrorHandlingTextField check={v => checkError(v, 'address_2')}
                                    validators={[validateRequired]}
                                    value={billingData?.address_2 || ''} variant='standard' name="address_2"
                                    onValChange={e => setBillingData({...billingData, address_2: e.target.value})}/>
        </Stack>
    },

        {
            name: 'Cég', content: <Stack spacing={1}>
                <Typography variant='caption' sx={{color: theme.palette.primary[500]}}>Számlázási név*</Typography>
                <ErrorHandlingTextField check={v => checkError(v, 'billing_name')}
                                        validators={[validateRequired]}
                                        value={billingData?.billing_name || ''} variant='standard' name="billing_name"
                                        onValChange={e => setBillingData({
                                            ...billingData,
                                            billing_name: e.target.value
                                        })}/>

                <Typography variant='caption' sx={{color: theme.palette.primary[500]}}>Adószám*</Typography>
                <ErrorHandlingTextField check={v => checkError(v, 'vat_number')}
                                        validators={[]}
                                        value={billingData?.vat_number || ''} variant='standard' name="vat_number"
                                        onValChange={e => setBillingData({
                                            ...billingData,
                                            vat_number: e.target.value
                                        })}/>

                <Typography variant='caption' sx={{color: theme.palette.primary[500]}}>Ország*</Typography>
                <Autocomplete
                    id="country-select-company"
                    sx={{width: '100%'}}
                    options={countries}
                    autoHighlight
                    value={billingData?.country || null}
                    onChange={(event, newValue) => {
                        setBillingData({...billingData, country: newValue});
                    }}
                    isOptionEqualToValue={(option, value) => option.code === value.code}
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option) => (
                        <Box component="li" sx={{'& > img': {mr: 2, flexShrink: 0}}} {...props}>
                            <img
                                loading="lazy"
                                width="20"
                                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                                alt=""
                            />
                            {option.label} ({option.code})
                        </Box>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant='standard'
                            fullWidth
                            inputProps={{
                                ...params.inputProps,
                                autoComplete: 'new-password', // disable autocomplete and autofill
                            }}
                        />
                    )}
                />

                <Stack spacing={1} direction='row' sx={{width: '100%'}}>
                    <Stack spacing={1} sx={{width: '100%'}}>

                        <Typography variant='caption'
                                    sx={{color: theme.palette.primary[500]}}>Irányítószám*</Typography>
                        <ErrorHandlingTextField check={v => checkError(v, 'postal_code')}
                                                validators={[validateRequired, validateNumber]}
                                                value={billingData?.postal_code || ''} variant='standard'
                                                name="postal_code"
                                                onValChange={e => setBillingData({
                                                    ...billingData,
                                                    postal_code: e.target.value
                                                })}/>
                    </Stack>

                    <Stack spacing={1} sx={{width: '100%'}}>
                        <Typography variant='caption' sx={{color: theme.palette.primary[500]}}>Város*</Typography>
                        <ErrorHandlingTextField check={v => checkError(v, 'city')}
                                                validators={[validateRequired]}
                                                value={billingData?.city || ''} variant='standard' name="city"
                                                onValChange={e => setBillingData({
                                                    ...billingData,
                                                    city: e.target.value
                                                })}/>
                    </Stack>
                </Stack>

                <Typography variant='caption' sx={{color: theme.palette.primary[500]}}>Megye*</Typography>
                <ErrorHandlingTextField check={v => checkError(v, 'state')}
                                        validators={[validateRequired]}
                                        value={billingData?.state || ''} variant='standard' name="address"
                                        onValChange={e => setBillingData({...billingData, state: e.target.value})}/>

                <Typography variant='caption' sx={{color: theme.palette.primary[500]}}>Cím*</Typography>
                <ErrorHandlingTextField check={v => checkError(v, 'address')}
                                        validators={[validateRequired]}
                                        value={billingData?.address || ''} variant='standard' name="address"
                                        onValChange={e => setBillingData({...billingData, address: e.target.value})}/>

                <Typography variant='caption' sx={{color: theme.palette.primary[500]}}>Cím második sora</Typography>
                <ErrorHandlingTextField check={v => checkError(v, 'address_2')}
                                        validators={[validateRequired]}
                                        value={billingData?.address_2 || ''} variant='standard' name="address_2"
                                        onValChange={e => setBillingData({...billingData, address_2: e.target.value})}/>

            </Stack>
        }]
    return <div className="data-container-fill">
        <BasicTabs tabs={tabs}/>
        <Stack spacing={1} marginBottom={2}>
            <Typography variant='caption' sx={{color: theme.palette.primary[500]}}>Fizetési mód*</Typography>
            <FormControl fullWidth>
                <Select
                    id="payment-select"
                    variant='standard'
                    value={billingData?.payment_type}
                    onChange={e => setBillingData({...billingData, payment_type: e.target.value})}
                >
                    {Object.keys(paymentTypeMap).map(k => <MenuItem key={k} value={k}>{paymentTypeMap[k]}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControlLabel control={<Checkbox
                checked={billingData?.accept}
                onChange={e => setBillingData({...billingData, accept: e.target.checked})}
                inputProps={{ 'aria-label': 'controlled' }}
            />} label={<Typography variant='caption' sx={{color: theme.palette.primary[500]}}>Elfogadom az <a href={aszfUrl} target='_blank'>ÁSZF</a>-et és az <a href={adatUrl} target='_blank'>Adatvédelmi
                tájékoztatót</a>*</Typography>} />

        </Stack>
        <Button endIcon={<HouseRoundedIcon/>} onClick={reserve} disabled={!(isBillingFilled() && isError() && billingData?.accept)} variant='contained'>Foglalás</Button>
    </div>
}

export default SelectPaymentData